import { HttpErrorResponse, HttpResponse } from "@angular/common/http";

/**
 * BSC · descarga del FOR-011 (F4.4): exportar.do y exportarConsolidado.do
 * contestan el .xlsx con Content-Disposition attachment, o un status con el
 * mensaje en texto plano (BscArchivoService): 401 sin sesión, 403 sin
 * permiso u otra empresa, 400 corte inválido o nada que exportar, 500 lo
 * demás. Se piden como blob con el interceptor normal para que viaje el
 * token (un window.open no lo lleva), como el FOS-005 de la matriz de riesgos.
 */

/**
 * El nombre del archivo de Content-Disposition (`filename*=UTF-8''…` o
 * `filename="…"`), sin rutas; nulo si no viene. En desarrollo, contra otro
 * origen, la cabecera no se expone por CORS y queda el nombre por omisión.
 */
export function nombreDeDisposicion(valor: string | null | undefined): string | null {
  if (!valor) {
    return null;
  }
  let nombre: string | null = null;
  const extendido = /filename\*\s*=\s*(?:UTF-8|utf-8)''([^;]+)/.exec(valor);
  if (extendido) {
    try {
      nombre = decodeURIComponent(extendido[1].trim().replace(/^"|"$/g, ""));
    } catch {
      nombre = null;
    }
  }
  if (!nombre) {
    const simple = /filename\s*=\s*("([^"]*)"|[^;]+)/.exec(valor);
    nombre = simple ? (simple[2] ?? simple[1]).trim() : null;
  }
  // Nunca una ruta: solo el último segmento.
  const limpio = nombre ? nombre.split(/[\\/]/).pop()?.trim() ?? "" : "";
  return limpio !== "" ? limpio : null;
}

/** Baja el blob como adjunto con el nombre del servidor o el de omisión (siempre .xlsx). */
export function guardarDescarga(res: HttpResponse<Blob>, porOmision: string): void {
  const blob = res.body;
  if (!blob) {
    return;
  }
  const base = nombreDeDisposicion(res.headers.get("Content-Disposition")) ?? porOmision;
  const nombre = /\.xlsx$/i.test(base) ? base : `${base.replace(/\.[^./\\]*$/, "")}.xlsx`;
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = nombre;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/**
 * Lo que se le dice a la persona cuando la descarga falla: el mensaje del
 * servidor (texto plano dentro del blob de error) o uno fijo por status.
 */
export async function mensajeDeDescarga(err: unknown, que: string): Promise<string> {
  const e = err instanceof HttpErrorResponse ? err : null;
  if (!e || e.status === 0) {
    return `No se pudo ${que}: sin conexión con el servidor.`;
  }
  if (e.status === 401) {
    return "Tu sesión caducó. Vuelve a entrar.";
  }
  let texto = "";
  try {
    if (e.error instanceof Blob) {
      texto = (await e.error.text()).trim();
    } else if (typeof e.error === "string") {
      texto = e.error.trim();
    }
  } catch {
    texto = "";
  }
  // Un texto largo o con etiquetas no es el mensaje de negocio (p. ej. una página de error del proxy).
  if (texto !== "" && texto.length <= 300 && !texto.includes("<")) {
    return texto;
  }
  if (e.status === 403) {
    return `No tienes permiso para ${que}.`;
  }
  return `No se pudo ${que}. Inténtalo de nuevo.`;
}
